export enum E_KHATTABAT_ONE_O_TWO_MESSAGE_HIDE_TYPE {
  FOR_ME = "for_me",
  FOR_EVERYONE = "for_everyone"
}
